// import logo from './logo.svg';
import React from 'react';
import './App.css';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import { Container } from 'react-bootstrap';
import LoginPage from './Pages/LoginPage';
import MainPage from './Pages/MainPage';
import RenginiaiPage from './Pages/RenginiaiPage';
import KursaiPage from './Pages/KursaiPage';
import Apie from './Pages/Apie';
import RenginiaiVaikamsPage from './Pages/RenginiaiVaikamsPage';
import Cart from './Pages/CartPage';
import KursasPage from './Pages/KursasPage';
import RenginysPage from './Pages/RenginysPage';
import AccountPage from './Pages/AccountPage';
import Registration from './Pages/Registration';
import PaymentPage from './Pages/PaymentPage';
import AcceptPage from './Pages/AcceptPage';
import PaymentCB from './Pages/PaymentCB';
import EsProjektas from './Pages/EsProjektas';

function App() {

  const myStyle = {
    padding: '0px',
  };

  return (
    <Container fluid style={myStyle}>
      <Router>
        <Routes>
          <Route path="/" element={<MainPage />}></Route>
          <Route path="/login" element={<LoginPage />}></Route>
          <Route path="/renginiai" element={<RenginiaiPage />}></Route>
          <Route path="/renginiai-vaikams" element={<RenginiaiVaikamsPage />}></Route>
          <Route path="/kursai" element={<KursaiPage />}></Route>
          <Route path="/kursai/:id" element={<KursasPage />}></Route>
          <Route path="/renginiai/:name" element={<RenginysPage />}></Route>
          <Route path="/apie" element={<Apie />}></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/account" element={<AccountPage />}></Route>
          <Route path="/registracija" element={<Registration />}></Route>
          <Route path="/apmokejimas" element={<PaymentPage />}></Route>
          <Route path="/accept" element={<AcceptPage />}></Route>
          <Route path="/cancel" element={<AcceptPage />}></Route>
          <Route path="/callback" element={<PaymentCB />}></Route>
          <Route path="/esprojektas" element={<EsProjektas />}></Route>
        </Routes>
      </Router>
    </Container>
  );
}

export default App;
